import AssetServiceOrderView from "@features/wx/dispatcher/components/pending/view/AssetServiceOrderView";
import { RouteObject } from "react-router-dom";
import AssetDetail from "../assets/components/Details/DetailsLanding";
import { AddFacility } from "./components/create/create";
import Facilities from "./components/Dashboard/landing";
import { FacilityDetails } from "./components/detail/detail";
export interface FacilitiesRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: FacilitiesRoute[];
}
export const axFacilitiesRoutes: FacilitiesRoute[] = [
  {
    path: "ax/asset-registry/facilities",
    element: <Facilities />,
  },
  {
    path: "ax/asset-registry/facilities/view/:id",
    element: <FacilityDetails />,
  },
  {
    path: "ax/asset-registry/facilities/create",
    element: <AddFacility />,
  },
  {
    path: "ax/asset-registry/facilities/edit/:id",
    element: <AddFacility />,
  },
  {
    path: "/ax/system-alerts/assets/view/:id",
    element: <AssetDetail />,
  },
  {
    path: "/ax/service-order/landing/view/:id",
    element: <AssetServiceOrderView />,
  },
];
